import { render, staticRenderFns } from "./frontOffice.vue?vue&type=template&id=7b50cd52&"
import script from "./frontOffice.ts?vue&type=script&lang=ts&"
export * from "./frontOffice.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports